export const BOOKING_PAGE_URL_VAR = "{予約ページURL}";